import React from 'react'
import PropTypes from 'prop-types'

const Loader = ({ classname }) => {
  return (
    <div className={ `loader ${classname}` }></div>
  )
}

Loader.propTypes = {
  classname: PropTypes.string
}

Loader.defaultProps = {
  classname: 'loader_classic_circle'
}

export default Loader



// WEBPACK FOOTER //
// ./src/components/_common/Loader.js